import React from 'react';

function formatTs(ts) {
  if (!ts) return '—';
  const d = new Date(ts);
  return (
    d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) +
    ' · ' +
    d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
  );
}

export default function ActionHistoryPanel({
  items = [],
  title = 'History',
  isLoading = false,
  renderItem,
}) {
  if (isLoading) {
    return (
      <div className="card p-5 space-y-3">
        <p className="text-[11px] font-mono uppercase tracking-widest text-text-faint">{title}</p>
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-14 rounded-lg bg-bg-s2 animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="card p-5 space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-[11px] font-mono uppercase tracking-widest text-text-faint">{title}</p>
        {items.length > 0 && (
          <span className="text-[10px] font-mono text-text-faint bg-bg-s2 px-2 py-0.5 rounded-full border border-border">
            {items.length} {items.length === 1 ? 'entry' : 'entries'}
          </span>
        )}
      </div>

      {items.length === 0 ? (
        <p className="text-xs text-text-faint py-1">
          No history yet — changes you make will appear here.
        </p>
      ) : (
        <div className="space-y-2">
          {items.map((item, idx) => (
            <div
              key={item.id || idx}
              className="rounded-lg border border-border bg-bg-s2 px-3.5 py-3 space-y-1.5"
            >
              <div className="flex items-start justify-between gap-3">
                <p className="text-[11px] text-text-faint font-mono">{formatTs(item.timestamp)}</p>
                {(item.change_source || item.principal_type) && (
                  <p className="text-[10px] text-text-faint truncate max-w-[140px]">
                    {item.change_source || item.principal_type}
                  </p>
                )}
              </div>
              {renderItem ? renderItem(item) : (
                <p className="text-xs text-text">
                  {item.label || (item.action || '').replace(/_/g, ' ')}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
